import { apolloClient } from '@/plugins/apollo'
import {
  CREATE_CANCEL_WAITLIST,
  IS_MY_CANCEL_WAITLIST_DATE_EXCLUDED,
  WAIT_LISTS,
  CANCEL_FACILITY_PARKING, DELETE_MY_CANCEL_WAIT_LIST

} from '@/api/graphql/waitlist'

export default {
  async createCancelWaitList (_context, {
    roomTypeId,
    checkInDate,
    checkOutDate
  }) {
    const res = await apolloClient.mutate({
      mutation: CREATE_CANCEL_WAITLIST,
      variables: {
        roomTypeId,
        checkInDate,
        checkOutDate,
        type: 'Member'
      }
    })

    return res.data.createMyCancelWaitList
  },
  // Advisory check: is the date range block-excluded (e.g. maintenance)?
  // Used to switch the wait-list modal message; creation is still allowed.
  async isCancelWaitListDateExcluded (_context, {
    roomTypeId,
    checkInDate,
    checkOutDate
  }) {
    const res = await apolloClient.query({
      query: IS_MY_CANCEL_WAITLIST_DATE_EXCLUDED,
      fetchPolicy: 'network-only',
      variables: {
        roomTypeId,
        checkInDate,
        checkOutDate
      }
    })

    return res.data.isMyCancelWaitListDateExcluded
  },
  async waitLists (context, {
    apollo,
    skip,
    take
  }) {
    return new Promise((resolve, reject) => {
      context.commit('setIsLoading', true)
      apollo.mutate({
        mutation: WAIT_LISTS
      }).then(data => {
        context.commit('setIsLoading', false)
        context.commit('setWaitList', data.data)
        resolve(data)
      }).catch(error => reject(error))
    })
  },
  async CancelWaitList (context, {
    apollo,
    id
  }) {
    return new Promise((resolve, reject) => {
      apollo.mutate({
        mutation: DELETE_MY_CANCEL_WAIT_LIST,
        variables: {
          id: id
        }
      }).then(() => {
        context.commit('deleteWaitList', id)
        resolve()
      }).catch(error => reject(error))
    })
  },
  async CancelParkingWaitList (context, {
    apollo,
    id
  }) {
    return new Promise((resolve, reject) => {
      apollo.mutate({
        mutation: CANCEL_FACILITY_PARKING,
        variables: {
          id: id
        }
      }).then(data => {
        context.commit('deleteParkingWaitList', id)
        resolve(data)
      }).catch(error => reject(error))
    })
  }
}
